import React from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import type { TripsListProps, BaseProductSet } from "@b2bportal/core-trips";
import { CoreTripsComponent } from "@b2bportal/core-types";
import { LoadingScreen, NoTripResults, useTripsList } from "@tenant/trips";
import styles from "./TripsList.module.scss";
import type { TripsPageContext } from "@/pages/Trips/components/MyTripsPage";

const COMPONENT_KEY = CoreTripsComponent.TripsList;

export const TripsList = <Products extends BaseProductSet>(
  props: TripsListProps<Products> & { pageContext?: TripsPageContext }
) => {
  const { context } = useTripsList(props);

  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <div className={block}>
      <LoadingScreen isLoading={context.isLoading} />
      {context.trips.length > 0 ? (
        <ul className={cn("trips-list")}>
          {context.trips.map((wrapper) => (
            <li className={cn("trip")} key={wrapper.reservationId}>
              <wrapper.component />
            </li>
          ))}
        </ul>
      ) : (
        <NoTripResults
          pageContext={props.pageContext}
          hasError={context.hasError}
        />
      )}
    </div>
  );
};
